export default "__VITE_ASSET__D1Zu3dsP__"